import script from "./PublicEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicEvents.vue?vue&type=script&setup=true&lang=js"

import "./PublicEvents.vue?vue&type=style&index=0&id=20c44204&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20c44204"]])

export default __exports__